interface FloraIconProps {
    iconText: string; 
}
export default function FloraIcon(props: FloraIconProps) {
    const AllIcons = require("@grupoboticario/flora-react-icons");
    const Icon = AllIcons[`${props.iconText}`];
    return <Icon />
}